module.exports = __webpack_public_path__ + "img/redeem-failed.2835ba2c.png";